(() => {
  if (customElements.get('elementre-deluxe-progress')) return;
  const calculate = (spend, rate, quantum) => {
    const thresholds = [1, 2, 3].map(n => Math.ceil(6000 * n * rate / quantum - 1e-9) * quantum);
    const allowance = thresholds.filter(value => spend >= value).length;
    const lower = allowance ? thresholds[allowance - 1] : 0;
    const fraction = allowance === 3 ? 3 : allowance + (spend - lower) / (thresholds[allowance] - lower);
    return { thresholds, allowance, remaining: allowance === 3 ? 0 : thresholds[allowance] - spend, fraction };
  };
  // A gift selection must never silently become a paid purchase.
  // Catalogue purchases have no marker and are preserved.
  const planGiftUpdate = (gifts, allowance) => {
    const updates = {};
    let removed = false;
    let free = gifts.filter(g => g.free).reduce((n,g) => n + g.quantity, 0);
    for (const gift of gifts) {
      if (gift.selectedGift && !gift.free) {
        updates[gift.key] = 0;
        removed = true;
      }
    }
    let excess = Math.max(0, free - allowance);
    for (const gift of gifts.filter(g => g.free)) {
      const remove = Math.min(excess, gift.quantity);
      if (remove) { updates[gift.key] = gift.quantity - remove; removed = true; }
      excess -= remove;
    }
    return {updates, blocked:false, removed};
  };
  const showGiftAdjustment = () => {
    const lang = (document.documentElement.lang || 'en').split('-')[0];
    const message = ({en:'Your discount has changed the number of free gifts available. Your cart has been updated automatically.',fr:'Votre remise a modifié le nombre de cadeaux offerts. Votre panier a été mis à jour automatiquement.',de:'Ihr Rabatt hat die Anzahl der kostenlosen Geschenke geändert. Ihr Warenkorb wurde automatisch aktualisiert.'})[lang];
    document.querySelectorAll('elementre-deluxe-progress').forEach(progress => {
      let note = progress.querySelector('[data-gift-adjustment]');
      if (!note) { note = document.createElement('p'); note.dataset.giftAdjustment = ''; note.setAttribute('role','status'); progress.prepend(note); }
      note.textContent = message || 'Your discount has changed the number of free gifts available. Your cart has been updated automatically.';
    });
  };
  let running = null;
  let dirty = false;
  let timer;
  const notificationKey = 'elementre-deluxe-notice-v1';
  let previousState = null;
  try { previousState = JSON.parse(sessionStorage.getItem(notificationKey)); } catch (_) {}
  const shouldNotify = (previous, next) => Boolean(previous && previous.currency === next.currency &&
    Number.isFinite(previous.spend) && next.spend > previous.spend && next.allowance > previous.allowance);
  let notice;
  const showUnlockNotice = allowance => {
    const language = (document.documentElement.lang || 'en').split('-')[0];
    const copy = {
      en: ['Your free deluxe samples', `Your basket now qualifies for ${allowance} free deluxe sample${allowance === 1 ? '' : 's'}. Review your selection before checkout.`, 'Review my samples', 'Continue shopping'],
      fr: ['Vos échantillons deluxe offerts', `Votre panier vous donne maintenant droit à ${allowance} échantillon${allowance === 1 ? '' : 's'} deluxe offert${allowance === 1 ? '' : 's'}. Vérifiez votre sélection avant de passer commande.`, 'Voir mes échantillons', 'Continuer mes achats'],
      de: ['Ihre kostenlosen Deluxe-Proben', `Ihr Warenkorb berechtigt Sie jetzt zu ${allowance} kostenlosen Deluxe-Probe${allowance === 1 ? '' : 'n'}. Prüfen Sie Ihre Auswahl vor dem Bezahlen.`, 'Meine Proben ansehen', 'Weiter einkaufen']
    }[language] || null;
    const text = copy || ['Your free deluxe samples', `Your basket now qualifies for ${allowance} free deluxe samples. Review your selection before checkout.`, 'Review my samples', 'Continue shopping'];
    if (!notice) {
      notice = document.createElement('dialog');
      notice.id = 'elementre-deluxe-unlocked';
      notice.setAttribute('aria-labelledby', 'elementre-deluxe-unlocked-title');
      notice.setAttribute('aria-describedby', 'elementre-deluxe-unlocked-description');
      notice.innerHTML = '<h2 id="elementre-deluxe-unlocked-title"></h2><p id="elementre-deluxe-unlocked-description"></p><a class="button"></a><button class="button button--secondary" type="button"></button>';
      const style = document.createElement('style');
      style.textContent = '#elementre-deluxe-unlocked{box-sizing:border-box;width:min(440px,calc(100vw - 32px));max-height:calc(100dvh - 32px);overflow:auto;padding:28px;border:1px solid #e4e7eb;background:#fff;color:#222;box-shadow:0 16px 60px #0003}#elementre-deluxe-unlocked::backdrop{background:#0006}#elementre-deluxe-unlocked h2{margin:0 0 16px;font-size:24px}#elementre-deluxe-unlocked p{line-height:1.5;margin:0 0 24px}#elementre-deluxe-unlocked .button{box-sizing:border-box;width:100%;margin-top:10px;text-align:center;white-space:normal}';
      document.head.append(style);
      document.body.append(notice);
      notice.querySelector('button').addEventListener('click', () => notice.close());
      notice.querySelector('a').addEventListener('click', () => notice.close());
    }
    notice.querySelector('h2').textContent = text[0];
    notice.querySelector('p').textContent = text[1];
    notice.querySelector('a').textContent = text[2];
    notice.querySelector('a').href = `${window.Shopify?.routes?.root || '/'}cart#deluxe-offer-heading`;
    notice.querySelector('button').textContent = text[3];
    if (!notice.open && typeof notice.showModal === 'function') notice.showModal();
  };
  const updateUnlockNotice = (source, blocked) => {
    const next = {currency:source.dataset.currency,spend:Number(source.dataset.spend),allowance:stateFor(source).allowance};
    const notify = !blocked && shouldNotify(previousState, next);
    const changed = previousState && (next.currency !== previousState.currency || next.spend !== previousState.spend || next.allowance !== previousState.allowance);
    previousState = next;
    try { sessionStorage.setItem(notificationKey, JSON.stringify(next)); } catch (_) {}
    // Close stale messaging when the basket or currency changes while the notice is open.
    if (notice?.open && (changed || blocked)) notice.close();
    if (notify && !document.querySelector('[data-quick-samples]')) showUnlockNotice(next.allowance);
  };
  const schedule = () => { clearTimeout(timer); timer = setTimeout(refresh, 150); };
  const readState = async () => {
    const url = new URL(`${window.Shopify?.routes?.root || '/'}cart`, location.origin);
    url.searchParams.set('section_id', 'elementre-deluxe-state');
    const response = await fetch(url, {cache: 'no-store'});
    if (!response.ok) throw Error('Cart refresh failed');
    const source = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('elementre-deluxe-progress');
    if (!source) throw Error('Cart state missing');
    return source;
  };
  const stateFor = source => {
    const currency = source.dataset.currency;
    const rate = currency === 'EUR' ? 1 : Number(window.Shopify?.currency?.rate);
    const spend = Number(source.dataset.spend);
    if (!(rate > 0) || !Number.isFinite(spend) || spend < 0 || (currency !== 'EUR' && window.Shopify?.currency?.active !== currency)) throw Error('Currency unavailable');
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency,currencyDisplay:'code'});
    return calculate(spend, rate, formatter.resolvedOptions().maximumFractionDigits === 0 ? 100 : 1);
  };
  const refresh = () => {
    dirty = true;
    if (running) return running;
    running = (async () => {
      let changes = 0;
      let adjusted = false;
      do {
        dirty = false;
        let source = await readState();
        if (dirty) continue;
        const gifts = JSON.parse(source.dataset.gifts || '[]');
        const plan = planGiftUpdate(gifts, stateFor(source).allowance);
        if (Object.keys(plan.updates).length) {
          adjusted = adjusted || plan.removed;
          if (++changes > 3) throw Error('Cart did not settle');
          const footer = document.getElementById('main-cart-footer');
          const footerSection = footer?.dataset.id;
          const sections = ['cart-icon-bubble', ...(footerSection ? [footerSection] : [])];
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
            method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({updates:plan.updates, sections, sections_url:location.pathname})
          });
          if (!response.ok) throw Error('Gift update failed');
          const cartData = await response.json();
          if (cartData.errors) throw Error('Gift update rejected');
          try { sessionStorage.setItem('elementre-gift-adjusted', '1'); } catch (_) {}
          if (document.querySelector('[data-quick-samples]')) {
            await updateQuickCart();
            dirty = true;
            continue;
          }
          location.reload();
          return;
        }
        document.querySelectorAll('elementre-deluxe-progress').forEach(target => {
          Object.assign(target.dataset, source.dataset);
          if (plan.blocked) target.unavailable(); else target.render();
        });
        updateUnlockNotice(source, plan.blocked);
        if (adjusted) showGiftAdjustment();
      } while (dirty);
    })().catch(() => {
      document.querySelectorAll('elementre-deluxe-progress').forEach(target => target.unavailable());
    }).finally(() => { running = null; });
    return running;
  };

  const updateInlineGiftStatus = source => {
    document.querySelectorAll('.elementre-cart-gift-note').forEach(node => node.remove());
    const summaries = document.querySelectorAll('[data-deluxe-selection-summary]');
    if (!source) { summaries.forEach(node => { node.hidden = true; }); return; }
    const state = stateFor(source);
    const selected = JSON.parse(source.dataset.gifts || '[]').filter(g => g.free).reduce((n,g) => n + g.quantity, 0);
    const remaining = Math.max(0, state.allowance - selected);
    const lang = (document.documentElement.lang || 'en').split('-')[0];
    const copy = lang === 'fr'
      ? [`Votre panier : ${remaining} échantillon(s) deluxe offert(s) à sélectionner.`, 'Choisir mes échantillons', `${selected} sur ${state.allowance} échantillon(s) offert(s) sélectionné(s). Les valeurs affichées sont indicatives ; votre sélection admissible est offerte.`, 'Ajoutez des produits admissibles pour débloquer un échantillon offert. Les échantillons ajoutés sans allocation disponible sont payants.']
      : lang === 'de'
      ? [`Ihr Warenkorb: ${remaining} kostenlose Deluxe-Probe(n) noch auswählbar.`, 'Proben auswählen', `${selected} von ${state.allowance} kostenlosen Proben ausgewählt. Die angezeigten Kaufwerte dienen zur Information; Ihre berechtigte Auswahl ist kostenlos.`, 'Fügen Sie berechtigte Produkte hinzu, um eine kostenlose Probe freizuschalten. Proben ohne verfügbares Geschenk-Kontingent sind kostenpflichtig.']
      : [`Your basket: ${remaining} free deluxe sample${remaining === 1 ? '' : 's'} still to select.`, 'Choose my samples', `${selected} of ${state.allowance} free deluxe samples selected. Purchase values are shown for reference; your eligible selection is complimentary.`, 'Add qualifying products to unlock a free deluxe sample. Samples added without an available free allocation are payable.'];
    summaries.forEach(node => {
      node.hidden = false;
      node.textContent = state.allowance ? (remaining ? copy[0] + ' ' : '') + copy[2] + (remaining ? '' : ' ' + copy[3].split('. ').slice(-1)[0]) : copy[3];
    });

  };

  let quickBusy = false;
  function organizeQuick() {
    const host = document.querySelector('[data-quick-samples]');
    const discount = host?.querySelector('.elementre-cart-discount');
    if (!discount || discount.closest('details')) return;
    const details = document.createElement('details');
    details.className = 'quick-samples__discount';
    const summary = document.createElement('summary');
    summary.textContent = discount.querySelector('[data-discount-label]')?.textContent || '';
    discount.before(details);
    details.append(summary,discount);
  }
  function bindQuickLayout() {
    const host = document.querySelector('[data-quick-samples]');
    if (!host) return;
    organizeQuick();
    new MutationObserver(organizeQuick).observe(host,{childList:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',bindQuickLayout,{once:true}); else bindQuickLayout();
  function renderQuick(source, unavailable = false) {
    const host = document.querySelector('[data-quick-samples]');
    if (!host || !host.querySelector('[data-quick-count]')) return;
    const discount = host.querySelector('.elementre-cart-discount');
    if (discount && !discount.closest('details')) {
      const details = document.createElement('details');
      details.className = 'quick-samples__discount';
      const summary = document.createElement('summary');
      summary.textContent = discount.querySelector('[data-discount-label]')?.textContent || host.dataset.discount;
      discount.before(details);
      details.append(summary,discount);
    }
    const total = document.querySelector('#main-cart-footer .totals__total-value');
    const mobileTotal = host.querySelector('[data-quick-total]');
    if (total && mobileTotal) mobileTotal.textContent = total.textContent;
    const grid = host.querySelector('[data-quick-grid]');
    if (unavailable) {
      host.querySelector('[data-quick-count]').textContent = host.dataset.error;
      host.querySelectorAll('[data-quick-toggle]').forEach(button => { button.disabled = true; });
      return;
    }
    const state = stateFor(source);
    host.dataset.unlocked = String(state.allowance > 0);
    const gifts = JSON.parse(source.dataset.gifts || '[]').filter(gift => gift.free);
    const selected = gifts.reduce((sum, gift) => sum + gift.quantity, 0);
    grid.hidden = state.allowance === 0;
    host.querySelector('[data-quick-count]').textContent = state.allowance
      ? host.dataset.count.replace('__SELECTED__', selected).replace('__COUNT__', state.allowance) + ' · ' + (selected >= state.allowance ? host.dataset.ready : host.dataset.remaining.replace('__COUNT__', state.allowance - selected))
      : host.dataset.locked;
    host.querySelectorAll('[data-quick-card]').forEach(card => {
      const count = gifts.filter(gift => String(gift.variantId) === card.dataset.quickCard).reduce((sum,gift) => sum + gift.quantity,0);
      const button = card.querySelector('[data-quick-toggle]');
      card.dataset.selected = String(count > 0);
      card.querySelector('[data-quick-selected]').hidden = !count;
      button.textContent = count ? host.dataset.remove : button.dataset.available === 'true' ? host.dataset.add : button.textContent;
      button.disabled = quickBusy || (!count && (selected >= state.allowance || button.dataset.available !== 'true'));
      button.setAttribute('aria-label', button.textContent + ': ' + card.querySelector('h3').textContent.trim());
      button.setAttribute('aria-pressed', String(count > 0));
    });
  }
  async function updateQuickCart() {
    const items = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    const sections = [items?.dataset.id, footer?.dataset.id, 'cart-icon-bubble'].filter(Boolean);
    const url = new URL(location.pathname, location.origin);
    url.searchParams.set('sections', sections.join(','));
    const response = await fetch(url, {cache:'no-store'});
    if (!response.ok) throw Error('Cart display unavailable');
    const html = await response.json();
    for (const id of sections) {
      if (!html[id]) throw Error('Cart section unavailable');
      const doc = new DOMParser().parseFromString(html[id], 'text/html');
      if (id === items?.dataset.id) {
        const fresh = doc.querySelector('cart-items');
        const current = document.querySelector('cart-items');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      } else if (id === footer?.dataset.id) {
        const fresh = doc.querySelector('.js-contents');
        if (fresh) footer.querySelector('.js-contents').innerHTML = fresh.innerHTML;
      } else {
        const current = document.getElementById(id);
        const fresh = doc.querySelector('.shopify-section');
        if (current && fresh) current.innerHTML = fresh.innerHTML;
      }
    }
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-quick-toggle]');
    if (!button) return;
    event.preventDefault();
    if (quickBusy || button.disabled) return;
    const host = button.closest('[data-quick-samples]');
    const message = host.querySelector('[data-quick-message]');
    quickBusy = true;
    host.setAttribute('aria-busy','true');
    host.querySelectorAll('[data-quick-toggle]').forEach(b => { b.disabled = true; });
    message.textContent = host.dataset.waiting;
    const checkoutButtons = [...document.querySelectorAll('button[name="checkout"]')];
    const originalDisabled = checkoutButtons.map(b => b.disabled);
    checkoutButtons.forEach(b => { b.disabled = true; });
    try {
      if (running) await running;
      const source = await readState();
      const state = stateFor(source);
      const gifts = JSON.parse(source.dataset.gifts || '[]');
      const selected = gifts.filter(g => g.free).reduce((n,g) => n + g.quantity,0);
      const gift = gifts.find(g => g.free && String(g.variantId) === button.dataset.quickToggle);
      const root = window.Shopify?.routes?.root || '/';
      if (!gift && selected >= state.allowance) throw Error('No allowance');
      const payload = gift ? {updates:{[gift.key]:gift.quantity - 1}} : {items:[{id:Number(button.dataset.quickToggle),quantity:1,properties:{_elementre_gift:'true'}}]};
      const response = await fetch(root + (gift ? 'cart/update.js' : 'cart/add.js'), {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});
      if (!response.ok) throw Error('Gift change rejected');
      const result = await response.json();
      if (result.errors) throw Error('Gift change rejected');
      await refresh();
      await updateQuickCart();
      const confirmed = await readState();
      const confirmedGifts = JSON.parse(confirmed.dataset.gifts || '[]');
      if (!gift && !confirmedGifts.some(g => g.free && String(g.variantId) === button.dataset.quickToggle)) throw Error('Gift not confirmed free');
      message.textContent = '';
      renderQuick(confirmed);
    } catch (_) {
      message.textContent = host.dataset.error;
    } finally {
      quickBusy = false;
      host.removeAttribute('aria-busy');
      checkoutButtons.forEach((b,i) => { b.disabled = originalDisabled[i]; });
      try { renderQuick(await readState()); } catch (_) { renderQuick(null,true); }
    }
  });
  document.addEventListener('submit', event => {
    if (quickBusy && (event.submitter?.name === 'checkout' || event.target.id === 'cart')) event.preventDefault();
  }, true);

  class DeluxeProgress extends HTMLElement {
    connectedCallback() { this.render(); }
    unavailable() {
      renderQuick(this,true);
      this.querySelector('[data-deluxe-allowance]').textContent = '';
      this.querySelector('[data-deluxe-next]').textContent = this.dataset.unavailable;
      this.querySelector('[data-deluxe-visual]').hidden = true;
    }
    render() {
      const currency = this.dataset.currency;
      const rate = currency === 'EUR' ? 1 : Number(window.Shopify?.currency?.rate);
      const spend = Number(this.dataset.spend);
      if (!(rate > 0) || !Number.isFinite(spend) || spend < 0 || (currency !== 'EUR' && window.Shopify?.currency?.active !== currency)) return this.unavailable();
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency,currencyDisplay:'code'});
      const quantum = formatter.resolvedOptions().maximumFractionDigits === 0 ? 100 : 1;
      const state = calculate(spend, rate, quantum);
      updateInlineGiftStatus(this);
      renderQuick(this);
      const selected = Math.min(state.allowance, JSON.parse(this.dataset.gifts || '[]').filter(g => g.free).reduce((sum, g) => sum + g.quantity, 0));
      const lang = (document.documentElement.lang || 'en').split('-')[0];
      const selection = lang === 'fr' ? `${selected} sur ${state.allowance} échantillon(s) offert(s) sélectionné(s)` : lang === 'de' ? `${selected} von ${state.allowance} kostenlosen Proben ausgewählt` : `${selected} of ${state.allowance} free deluxe samples selected`;
      const tierLabels = lang === 'fr' ? ['Sélectionné', 'À sélectionner', 'Non débloqué'] : lang === 'de' ? ['Ausgewählt', 'Auswählbar', 'Gesperrt'] : ['Selected', 'Choose sample', 'Locked'];
      const allowance = lang === 'fr' ? `Échantillons deluxe offerts avec votre panier actuel : ${state.allowance}.` : lang === 'de' ? `Kostenlose Deluxe-Proben mit Ihrem aktuellen Warenkorb: ${state.allowance}.` : `Free deluxe samples with your current basket: ${state.allowance}.`;
      const next = state.allowance === 3 ? this.dataset.maximum : this.dataset.next.replace('__AMOUNT__', formatter.format(state.remaining / 100));
      this.querySelector('[data-deluxe-allowance]').textContent = allowance;
      this.querySelector('[data-deluxe-next]').textContent = next;
      this.querySelector('[data-deluxe-visual]').hidden = false;
      const bar = this.querySelector('[role=progressbar]');
      bar.setAttribute('aria-valuenow', String(selected));
      bar.setAttribute('aria-label', selection);
      let label = this.querySelector('.deluxe-progress__selection');
      if (!label) { label = document.createElement('p'); label.className = 'deluxe-progress__selection'; bar.before(label); }
      label.textContent = selection;
      bar.setAttribute('aria-valuetext', `${selection}. ${allowance} ${next}`);
      this.querySelector('[data-deluxe-fill]').style.width = `${selected / 3 * 100}%`;
      this.querySelectorAll('[data-deluxe-tier]').forEach((tier, index) => {
        tier.dataset.unlocked = String(index < state.allowance);
        tier.dataset.selected = String(index < selected);
        let status = tier.querySelector('.deluxe-progress__tier-status');
        if (!status) { status = document.createElement('span'); status.className = 'deluxe-progress__tier-status'; tier.append(status); }
        status.textContent = tierLabels[index < selected ? 0 : index < state.allowance ? 1 : 2];
        tier.querySelector('[data-deluxe-threshold]').textContent = lang === 'fr' ? `Dès une valeur de ${60 * (index + 1)} euros Échantillon` : lang === 'de' ? `Ab einem Wert von ${60 * (index + 1)} Euro Probe` : `From Value Euro ${60 * (index + 1)} Sample`;
        tier.insertBefore(tier.querySelector('[data-deluxe-threshold]'), tier.querySelector('.deluxe-progress__number'));
      });
    }
  }
  customElements.define('elementre-deluxe-progress', DeluxeProgress);
  // Keep shoppers at the selector until their current free allocation is filled.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('.deluxe-options')) return;
    const destination = form.querySelector('input[name="return_to"]');
    const progress = form.closest('.elementre-deluxe-offer')?.querySelector('elementre-deluxe-progress');
    if (!destination || !progress) return;
    try {
      const allowance = stateFor(progress).allowance;
      const gifts = JSON.parse(progress.dataset.gifts || '[]');
      const selected = gifts.filter(gift => gift.free).reduce((sum, gift) => sum + gift.quantity, 0);
      const adding = Number(new FormData(form).get('quantity')) || 1;
      const marker = form.querySelector('input[name="properties[_elementre_gift]"]');
      if (marker) marker.disabled = selected + adding > allowance;
      const cart = `${window.Shopify?.routes?.root || '/'}cart`;
      destination.value = selected + adding < allowance ? `${cart}#deluxe-offer-heading` : cart;
    } catch (_) { /* Preserve the ordinary cart return if eligibility is unavailable. */ }
  });
  const bind = () => {
    try { if (sessionStorage.getItem('elementre-gift-adjusted') === '1') { sessionStorage.removeItem('elementre-gift-adjusted'); showGiftAdjustment(); } } catch (_) {}
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (event.source !== 'elementre-deluxe-sync') refresh();
    });
    // Observe completed Ajax mutations, including discount-code updates from other components.
    if (typeof PerformanceObserver !== 'undefined') {
      const observer = new PerformanceObserver(list => {
        if (list.getEntries().some(entry => {
          const url = new URL(entry.name, location.origin);
          return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
        })) schedule();
      });
      observer.observe({type:'resource'});
    }
    window.addEventListener('pageshow', refresh);
    window.addEventListener('focus', refresh);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once:true}); else bind();
})();
